import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=3ad0477b&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=3ad0477b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad0477b",
  null
  
)

export default component.exports